import qestIds from '../../../QestIds';

const getConfig = (prefix: string) => ({});

export { getConfig };

export default {
  [qestIds.soilClassification.ASTM.estimated_Al]: getConfig,
};
